import { CalendarClock } from 'lucide-react';
import { infobulleDatesFlexibles } from './format';

/**
 * « Dates flexibles » (case cochée dans Nouvelle demande) : la personne absente peut décaler ses dates si personne n'est
 * trouvé·e. Montré à la gestion, à la personne absente et à l'auteur·rice — l'information servait à rien tant qu'elle
 * n'était affichée nulle part (DECISIONS §26). Le texte visible dit l'essentiel ; l'info-bulle et le nom accessible l'expliquent.
 */
export function BadgeDatesFlexibles({ absentNom, estLaPersonneAbsente }: { absentNom?: string | null; estLaPersonneAbsente: boolean }) {
  const explication = infobulleDatesFlexibles(absentNom, estLaPersonneAbsente);
  return (
    <span className="badge badge-flex" title={explication} aria-label={`Dates flexibles. ${explication}`}>
      <CalendarClock size={12} aria-hidden="true" />
      Dates flexibles
    </span>
  );
}
